export default class RemoveSnippet {
  constructor(context) {
    this.context = context;
  }

  run(snippetId) {
    this.context.stores.snippets.setPendingDelete(snippetId);
    this.context.gateways.snippet.remove(snippetId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/remove_snippet.js